import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Http } from "@angular/http";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { environment as ENV } from "../environments/environment.prod";
import { getCookie } from "../utils/auth";
import { Helpers } from "./helpers";

@Component({
  selector: "body",
  templateUrl: "./app.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  title = "app";
  globalBodyClass =
    "m-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-light m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default";
  userData: any;
  constructor(
    private httpClient: HttpClient,
    private http: Http,
    private _router: Router
  ) {
    this.userData = {};
  }
  ngOnInit() {
    var redirect_url = ENV.redirectUrl;
    redirect_url = btoa(redirect_url);
    redirect_url = encodeURIComponent(redirect_url);
    var jwt = { token: getCookie("MyToken") };
    if (!jwt || !jwt.token) {
      location.href = ENV.loginURL + "login/index/" + redirect_url;
    }

    this._router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        Helpers.setLoading(true);
        Helpers.bodyClass(this.globalBodyClass);
      }
      if (route instanceof NavigationEnd) {
        Helpers.setLoading(false);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts